import React from 'react'

import { TableCell } from '@mui/material'
import { TextCell } from '@abra/elements/table/cells/basics/'

const Row = ({ row, isSelected, ...props }) => <>
  <TableCell size={'small'}><TextCell value={_.get(row, 'taxicounter.name')} /></TableCell>
  <TableCell size={'small'}><TextCell value={_.get(row, 'taxicounter.start_zone.name')} /></TableCell>
  <TableCell size={'small'}><TextCell value={_.get(row, 'taxicounter.pricing.flat_rate')} /></TableCell>
</>

export default React.memo(Row)
